<template>
    <main class="btcdirect-widget-content">
        <slot />
    </main>
</template>

<style lang="scss" scoped>
@use '@@scss/flex';

.btcdirect-widget-content {
    @include flex.flex;
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;
}
</style>
